module.exports = __webpack_public_path__ + "img/logo-with-txt.a6133e17.svg";